<!--page starts-->
<section class="page-wrapper">
    <div class="fixture-section margin-top-152 cf">
        <div class="container">
            <div class="fixture-hero-detail cf">
                <div class="fixture-hero-titel">
                    <div class="fixture-hero-titel-inner">
                        <h2>FIXTURES & RESULTS</h2>
                        <!--<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                            been the industry's standard dummy</p>-->
                    </div>
                </div>
                <div class="leicester-detail-right" *ngIf="livematcheList?.data?.length > 0">
                    <h4>{{livematchesList?.first_name}} vs {{livematchesList?.second_name}}</h4>
                
                    <div class="leicester-right-match-box">
                        <div class="leicester-right-match-box-inner-top">
                            <div class="leicester-right-match-box-main ">
                                <div class="leicester-team-logo-box">
                                    <div class="leicester-team-logo-image" *ngIf="livematchesList?.first_image">
                                        <img [src]="livematchesList?.first_image">
                                    </div>
                                    <div class="leicester-team-logo-score">
                                        <p></p>
                                    </div>
                                </div>
                                <!-- <div class="leicester-team-score-right">
                                    <h4>301 & 272/7d</h4>
                                </div> -->
                            </div>
                        
                            <div class="leicester-right-match-box-main-vs">
                            <h3>vs</h3>
                            </div>
                            <div class="leicester-right-match-box-main">
                                <div class="leicester-team-logo-box">
                                    <div class="leicester-team-logo-image" *ngIf="livematchesList?.second_image">
                                        <img [src]="livematchesList?.second_image">
                                    </div>
                                    <!-- <div class="leicester-team-logo-score">
                                        <p>(80.3 ov, target 237)</p>
                                    </div> -->
                                </div>
                                <!-- <div class="leicester-team-score-right">
                                    <h4>301 & 272/7d</h4>
                                </div> -->
                            </div>
                            <div class="leicester-team-logo-score-content">
                                <p>{{livematchesList?.series_catagory_title}}</p>
                            </div>
                        </div>
                        <div class="match-report-btn">
                            <div class="match-report-btn-inner">
                                <a [routerLink]="['/livescore', livematchesList?.matchid]" *ngIf="livematchesList?.matchid">Watch Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixture-vector-image">
            <div class="fixture-vector-image-inner">
                <img src="assets/images/ic-logo.png">
            </div>
        </div>
    </div>
    <div class="fixture-season-section cf">
        <div class="container">
            <div class="fixture-season-detail">
                <ul>
                    <li>
                        <a href="javascript:void(0)">
                            <select class="select_tab">
                                <optgroup>
                                    <option value="{{season?.season_type_id}}" class="{{i}}"
                                        *ngFor="let season of seasonList?.data; let i = index">{{season?.title}} Season
                                    </option>
                                </optgroup>
                            </select>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="fixture-season-tab-section cf" *ngIf="matchesnewList?.data?.length > 0">
            <div class="fixture-season-tab-detail">
                <ul class="maintab">
                    <li class="courses-name" [ngClass]="{ active: i == 0 }" id="tab-{{maincat?.series_type_id}}"
                        *ngFor="let maincat of matchesnewList?.data; let i = index"><a
                            href="javascript:void(0)">{{maincat?.title}}</a></li>
                    <!-- <li class="courses-name" id="tab-2"><a href="javascript:void(0)" >Second XI Fixtures</a></li>
                       <li class="courses-name" id="tab-3"><a href="javascript:void(0)" >Academy Fixtures</a></li>
                       <li class="courses-name" id="tab-5"><a href="javascript:void(0)" >Women's Fixtures</a></li> -->
                </ul>
            </div>
            <div class="fixture-season-tab-content-detail course-main-content cf " [ngClass]="{ active: i == 0 }"
                id="tab-{{maincat?.series_type_id}}-content"
                *ngFor="let maincat of matchesnewList?.data; let i = index">
                <div class="fixture-season-tab-inner">
                    <div class="container">
                        <div class="fixture-season-tab-inner-detail">
                            <ul class="maintab-inner">
                                <li class="inner-name" [ngClass]="{ active: i == 0 }"
                                    id="subtab-{{subcat?.series_catagory_id}}"
                                    *ngFor="let subcat of maincat?.series_catagory; let i = index"><a
                                        href="javascript:void(0)">{{subcat?.title}}</a></li>
                                <!-- <li class="inner-name" id="tweenty"><a href="javascript:void(0)">tweenty</a></li> -->
                            </ul>
                        </div>
                        <div class="fixture-season-tab-inner-detail-content inner-main-content"
                            [ngClass]="{ active: i == 0 }" id="subtab-{{subcat?.series_catagory_id}}-content"
                            *ngFor="let subcat of maincat?.series_catagory; let i = index">
                            <div class="container">
                                <div class="fixture-season-tab-content-top">
                                    <div class="fixture-season-tab-celender">
                                        <div class="celender-box">
                                            <div class="row text-center">
                                                <div class="col-md-4">
                                                    <div class="btn-group">
                                                        <div class="btn btn-primary Previous" mwlCalendarPreviousView
                                                            [view]="view" [(viewDate)]="viewDate"> </div>
                                                        <div class="btn btn-outline-secondary" mwlCalendarToday
                                                            [(viewDate)]="viewDate"></div>
                                                        <div class="btn btn-primary next" mwlCalendarNextView
                                                            [view]="view" [(viewDate)]="viewDate"></div>
                                                    </div>
                                                </div>
                                                <div class="month-name">
                                                    <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                                                </div>
                                                <div class="calendarmenu">
                                                    <!--<ul>
                                                        <li class="menu-team-top">
                                                            <a [href]="googleCalendarEventUrl" target="_blank">Add To Calender</a>
                                                        </li>
                                                    </ul>-->

                                                </div>
                                            </div>
                                            <br />
                                            <div *ngIf="events$ | async;  let events">
                                                <div [ngSwitch]="view">
                                                    <mwl-calendar-month-view *ngSwitchCase="'month'"
                                                        [viewDate]="viewDate" [events]="events"
                                                        [activeDayIsOpen]="activeDayIsOpen"
                                                        (dayClicked)="dayClicked($event.day)"
                                                        (eventClicked)="eventClicked($event.event)">
                                                    </mwl-calendar-month-view>
                                                    <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="viewDate"
                                                        [events]="events" (eventClicked)="eventClicked($event.event)">
                                                    </mwl-calendar-week-view>
                                                    <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="viewDate"
                                                        [events]="events" (eventClicked)="eventClicked($event.event)">
                                                    </mwl-calendar-day-view>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="fixture-season-tab-matches">
                                        <div class="second-fixtures-detail-tab">
                                            <div class="second-fixtures-detail-tab-list">
                                                <ul class="subtab">
                                                    <li class="fixtures-name ok"
                                                        id="upcoming-{{subcat?.series_catagory_id}}"><a href="#"
                                                            id="Upcoming">Upcoming Matches</a></li>
                                                    <li class="fixtures-name " id="past-{{subcat?.series_catagory_id}}">
                                                        <a href="#" id="Past">Past Matches</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="second-fixtures-detail-tab-detail fixtures-main-content ok"
                                            id="upcoming-{{subcat?.series_catagory_id}}-content">
                                            <div class="leicester-match-section cf">
                                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel"
                                                    [config]="slidematchbookConfig">
                                                    <div ngxSlickItem class="leicester-match-box-slide slide cf"
                                                        *ngFor="let upcoming of subcat?.upcoming_match">
                                                        <div class="leicester-match-box" [ngStyle]="{'background-image':'url(' + upcoming?.image + ')'}">
                                                            <div class="leicester-match-box-left">
                                                                <div class="leicester-match-box-left-logo-box">
                                                                    <div class="leicester-match-left"><img
                                                                            [src]="upcoming?.first_image"></div>
                                                                    <div class="leicester-match-center">
                                                                        <h2>vs</h2>
                                                                    </div>
                                                                    <div class="leicester-match-right"><img
                                                                            [src]="upcoming?.second_image"></div>
                                                                </div>
                                                                <div class="leicester-match-box-left-content">
                                                                    <h4>{{upcoming?.location}}</h4>
                                                                    <p>{{upcoming?.date_time | amDateFormat: "DD MMM
                                                                        YYYY,"}} Starts {{upcoming?.date_time |
                                                                        amDateFormat: "HH:mm"}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="leicester-match-box-right">
                                                                <div class="leicester-match-box-right-btn"><a
                                                                        href="{{upcoming?.redirect_url}}" tabindex="-1" target="_blank" *ngIf="upcoming?.redirect_url && upcoming?.is_sold_out == 'No'">Book
                                                                        Tickets</a>
                                                                        <a *ngIf="upcoming?.is_sold_out == 'Yes'" disabled class="grey">SOLD OUT</a>
                                                                    </div>
                                                            </div>
                                                            <div class="leicester-match-overlay"></div>
                                                        </div>
                                                    </div>
                                                </ngx-slick-carousel>
                                            </div>
                                        </div>
                                        <div class="second-fixtures-detail-tab-detail fixtures-main-content "
                                            id="past-{{subcat?.series_catagory_id}}-content">
                                            <div class="leicester-match-section cf">
                                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel"
                                                    [config]="slidematchreportConfig">
                                                    <div ngxSlickItem class="leicester-match-box-slide slide cf"
                                                        *ngFor="let past of subcat?.past_match">
                                                        <div class="leicester-match-box" [ngStyle]="{'background-image':'url(' + past?.image + ')'}">
                                                            <div class="leicester-match-box-left">
                                                                <div class="leicester-match-box-left-logo-box">
                                                                    <div class="leicester-match-left"><img
                                                                            [src]="past?.first_image"></div>
                                                                    <div class="leicester-match-center">
                                                                        <h2>vs</h2>
                                                                    </div>
                                                                    <div class="leicester-match-right"><img
                                                                            [src]="past?.second_image"></div>
                                                                </div>
                                                                <div class="leicester-match-box-left-content">
                                                                    <h4>{{past?.location}}</h4>
                                                                    <p>{{past?.date_time | amDateFormat: "DD MMM
                                                                        YYYY,"}} Starts {{past?.date_time |
                                                                        amDateFormat: "HH:mm"}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="leicester-match-box-right">
                                                                <div class="leicester-match-box-right-btn"><a
                                                                        href="{{past?.redirect_url}}" tabindex="-1" target="_blank" *ngIf="past?.redirect_url && past?.is_sold_out == 'No'">Book
                                                                        Tickets</a>
                                                                        <a *ngIf="past?.is_sold_out == 'Yes'" disabled class="grey">SOLD OUT</a>
                                                                    </div>
                                                            </div>
                                                            <div class="leicester-match-overlay"></div>
                                                        </div>
                                                    </div>
                                                </ngx-slick-carousel>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="fixture-season-tab-content-bottom cf">
                                    <div class="fixture-season-tab-content-bottom-detail">
                                        <div class="fixture-season-tab-content-image"><img
                                                src="assets/images/bg9img.png"></div>
                                        <div class="fixture-season-tab-content-text">
                                            <h2>2021 Membership - On Sale Now</h2>
                                            <h4>A New Breed of Fox is here!</h4>
                                            <div class="fixture-season-content-text">
                                                <p>Leicestershire County Cricket Club announce the 2021 membership
                                                    offering as part of the #ANewBreed campaign. A New Breed of Fox
                                                    emphasises the new chapter of the club, both on and off the pitch.
                                                </p>
                                                <p>2021 Memberships launch off the back of an encouraging 2020 season
                                                    whereby, the Running Foxes reached the Quarter Finals of the
                                                    Vitality Blast for the first time in 3 years. </p>
                                            </div>
                                            <div class="fixture-season-tab-content-text-btn"><a
                                                    href="https://ticketing-lccc.crmporium.com/season-tickets.aspx" target="_blank">VIEW DETAILS</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>

    </div>
</section>
<!-- page ends-->